import { memo as Memo, useMemo, useCallback } from 'react'
import { useRouter } from 'next/router'

//* HOC's
import withDataContext from 'context/consumerHOC/DataConsumer'

//* Helpers
import { routerToPathAndQuery } from 'helpers'

//* Components
import Page from 'components/common/Page'
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import CategoryFilter from 'components/common/CategoryFilter'
import Pagination from 'components/common/Pagination'
import EventsSection from 'components/pages/events/EventsSection'

//* Style
import EventsStyle from 'styles/pages/media/EventsStyle'

const Events = Memo(({ pages, events, pageParams, selectedLang }) => {
	//! Router
	const router = useRouter()

	//! Page Data
	const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, pageParams.name, selectedLang])

	//! events data
	const eventsData = useMemo(() => events?.[pageParams.queryName]?.[selectedLang], [events, pageParams.queryName, selectedLang])

	//! Query Param Keys
	const queryParamKeys = useMemo(() => pageParams.postType.queryParamKeys, [pageParams])

	const queryPageKey = useMemo(() => queryParamKeys[0], [queryParamKeys])
	const queryCatKey = useMemo(() => queryParamKeys[1], [queryParamKeys])

	//! On Filter Param Change
	const onFilterChange = useCallback(
		(type, typeId, multiple = false) => {
			const { pathname, query } = routerToPathAndQuery(router, type, typeId, multiple)

			type != queryPageKey && delete query[queryPageKey] //? Page Param Removed on Category Change

			router.push({ pathname, query }, undefined)
		},
		[router.query, queryPageKey]
	)

	return (
		<Page
			className={'events'}
			meta={pageData?.content?.meta}
		>
			{pageData && (
				<EventsStyle>
					<Container>
						<Text className={'h1 font-montserrat textBlack-100 events-title'}>{pageData.content.title}</Text>
					</Container>

					{pageData.categories && pageData.categories.length > 0 ? (
						<CategoryFilter
							queryCatKey={queryCatKey}
							categories={pageData.categories}
							onChange={(cat) => onFilterChange(queryCatKey, cat)}
						/>
					) : null}

					{eventsData && (
						<>
							{eventsData.events && eventsData.events.length > 0 ? <EventsSection items={eventsData.events} /> : null}

							<Container>
								<Pagination
									total={eventsData.total}
									pageSize={eventsData.perPage}
									onCategoryChange={onFilterChange}
								/>
							</Container>
						</>
					)}
				</EventsStyle>
			)}
		</Page>
	)
})

export default withDataContext(Events, ['pages', 'events'])
